module.exports = __webpack_public_path__ + "9f5f3276373a8a5a1ca5c858ccb8a017.svg";